import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const CheckOutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
`

export const CheckOutSubline = styled.p`
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.5rem;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const FilterBar = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`

export const FilterLabel = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`

export const PersonCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
`

export const PersonName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const LocationCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};

  svg {
    width: 0.85rem;
    height: 0.85rem;
    flex: none;
  }
`

export const DateCell = styled.span<{ $danger?: boolean }>`
  font-size: ${tokens.font.label};
  font-variant-numeric: tabular-nums;
  color: ${(props) => (props.$danger ? tokens.status.danger.fg : tokens.text.secondary)};
  font-weight: ${(props) => (props.$danger ? 600 : 400)};
`

export const OverdueTag = styled.span`
  display: block;
  margin-top: 0.15rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.status.danger.fg};
  font-weight: 600;
`

export const BedTag = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.accent.base};
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
`

export const ActionWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;

  & > button {
    white-space: nowrap;
  }
`
